import type { RootStateType } from '@/features/store';

/**
 * Получить выбранные элементы для cравнения
 */
const selectedComparisonItemsSelector = (state: RootStateType) =>
  state.comparison.selected || [];

export default selectedComparisonItemsSelector;
